import authHeader from './auth.header.js';
import constants from './constants.js'

const HOST_URL = constants.API_URL

export async function fetchThematicsFromCountry(countryCode) {

    const response = await fetch(`${HOST_URL}/thematics/${countryCode}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    return await response.json()
}

export async function fetchAllThematics() {
    const user = JSON.parse(localStorage.getItem("user"));
    const response = await fetch(`${HOST_URL}/thematics/name/${user.id}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    return await response.json()
}

export async function fetchRawThematics() {
    const response = await fetch(`${HOST_URL}/thematics/raw`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    return await response.json()
}

export async function fetchCseFromThematic(name, countryCode) {
    const response = await fetch(`${HOST_URL}/thematics/cse/${name}/${countryCode}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return []
    }

    return await response.text()
}

export async function fetchCountryInfo(country) {
    const response = await fetch(`${HOST_URL}/thematics/country/infos/${country}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    return await response.json()
}

export async function toggleUserThematic(user_id, thematic_id) {
    const response = await fetch(`${HOST_URL}/thematics/user/toggle`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify({ user_id: user_id, thematic_id: thematic_id })
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return false
    }

    return true
}

export async function fetchLinksThematics(thematicName, countryCode, igo) {
    let url = `${HOST_URL}/thematics/links/${countryCode}/${thematicName}`;
    if (igo) {
        url += `/${igo}`;
    }
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    if (response.status === 204) {
        return []
    }

    return await response.json()
}

export async function fetchCse(firstElement, lastElement, query) {
    const response = await fetch(`${HOST_URL}/thematics/cse/get/${firstElement}/${lastElement}${query ? "/"+query : ""}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                ...authHeader(),
            },
        })
    
        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.text())
            return []
        }
    
        const jsonResponse = await response.json()
        return jsonResponse
}

export async function getOneCse(id) {
    const response = await fetch(`${HOST_URL}/thematics/cse/get/${id}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return []
    }

    const jsonResponse = await response.json()
    return jsonResponse

}

export async function addCse(request) {
    const userAdmin = JSON.parse(localStorage.getItem('user'))
    if (!userAdmin.admin && userAdmin.admin_access !== 4) return
    const response = await fetch(`${HOST_URL}/thematics/cse/add`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
        body: JSON.stringify(request)
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }

    return true
}

export async function deleteCse(id) {
    const userAdmin = JSON.parse(localStorage.getItem('user'))
    if (!userAdmin.admin && userAdmin.admin_access !== 4) return
    const response = await fetch(`${HOST_URL}/thematics/cse/delete/${id}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }

    return true
}

export async function updateCse(request) {
    const userAdmin = JSON.parse(localStorage.getItem('user'))
    if (!userAdmin.admin && userAdmin.admin_access !== 4) return
    const response = await fetch(`${HOST_URL}/thematics/cse/update`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
        body: JSON.stringify(request)
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }

    return true
}

export async function fetchLinksThematicsWithOffsetAndLimit(country, firstElement, lastElement, query) {
    const response = await fetch(`${HOST_URL}/thematics/links/get/${country}/${firstElement}/${lastElement}${query ? "/"+query : ""}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return []
    }

    const jsonResponse = await response.json()
    return jsonResponse
}

export async function fetchOneLink(id) {
    const response = await fetch(`${HOST_URL}/thematics/links/get/${id}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return []
    }

    const jsonResponse = await response.json()
    return jsonResponse

}

export async function addLink(request) {
    const response = await fetch(`${HOST_URL}/thematics/links/add`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
        body: JSON.stringify(request)
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }

    return true
}

export async function deleteLink(id) {
    const response = await fetch(`${HOST_URL}/thematics/links/delete/${id}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }

    return true
}

export async function updateLink(request) {
    const response = await fetch(`${HOST_URL}/thematics/links/update`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader(),
        },
        body: JSON.stringify(request)
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }

    return true
}

export async function getSearchInCseThematic(thematicName, countryCode) {
    const response = await fetch(`${HOST_URL}/thematics/cse/get/search/${thematicName}/${countryCode}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    return await response.json()
}


const thematics = {
    fetchThematicsFromCountry
}
export default thematics;
